/**
 * =============================================================================
 * Checkout-Modus je Mandant (a-047)
 * =============================================================================
 * Quelle: tenant_settings, setting_key = 'checkout_mode' (setting_value).
 * functions/api/tenant/resolve.js liefert tenant_settings bereits als tenant.settings aus.
 *
 * Werte:
 *   'inquiry'         -> heutiger Anfragekorb (Default, auch bei fehlendem/unbekanntem Wert)
 *   'stripe_checkout' -> echter Kauf über Stripe-Checkout
 */

export const CHECKOUT_MODES = Object.freeze({
  INQUIRY: 'inquiry',
  STRIPE_CHECKOUT: 'stripe_checkout',
});

export const DEFAULT_CHECKOUT_MODE = CHECKOUT_MODES.INQUIRY;

/**
 * Liefert den Checkout-Modus eines Mandanten. Unbekannte oder fehlende Werte
 * fallen auf 'inquiry' zurück (fail-closed: kein Zahlungsweg ohne explizite Freigabe).
 */
export function getCheckoutMode(tenant) {
  const raw = tenant?.settings?.checkout_mode;
  // Die Resolve-Antwort liefert skalare Werte als String; ein Objekt (Legacy) zählt nicht.
  if (typeof raw !== 'string') return DEFAULT_CHECKOUT_MODE;
  return raw.trim() === CHECKOUT_MODES.STRIPE_CHECKOUT
    ? CHECKOUT_MODES.STRIPE_CHECKOUT
    : DEFAULT_CHECKOUT_MODE;
}

/** true, wenn der Mandant echten Kauf über Stripe aktiviert hat. */
export function isStripeCheckout(tenant) {
  return getCheckoutMode(tenant) === CHECKOUT_MODES.STRIPE_CHECKOUT;
}
